module.exports = __webpack_public_path__ + "static/media/wizualizacja-98.3e78a9e8.png";